// 🔒
export const benefits = [
  {
    id: 1,
    eyebrow: "Passive Income",
    title: "Turn your knowledge into scalable income",
    description:
      "Create your programs once and continue earning as new users discover, purchase, and follow them inside the app."
  },
  {
    id: 2,
    eyebrow: "Revenue",
    title: "Keep 75% of every sale",
    description:
      "Earn meaningful revenue from every program sold through the platform while staying focused on delivering high-value training content."
  },
  {
    id: 3,
    eyebrow: "Easy Publishing",
    title: "Show your programs in a premium format",
    description:
      "We present your training content in a polished in-app experience that feels clear, elevated, and easy for users to follow."
  },
  {
    id: 4,
    eyebrow: "Full Service",
    title: "You create the content, we handle the rest",
    description:
      "From structure and implementation to presentation and platform experience, we take care of the technical side so you can focus on coaching."
  }
];
// 🔒